import { Box } from '@pets-ui/Box/Box'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { type ReactNode } from 'react'

export interface ProductSalesTagProps {
  show?: boolean
  children: ReactNode
}

export const ProductSalesTag = (props: ProductSalesTagProps) => {
  const { show, children } = props

  if (!show) return children

  return (
    <Box position="relative" overflow="hidden">
      <Box position="absolute" top={0} left={0} right="20%" backgroundColor={colors.red600} transform="rotate(-45deg) translate(-25%, -50%)" zIndex={1}>
        <Text variant="caption" align="center" color={colors.white}>Sale</Text>
      </Box>
      {children}
    </Box>
  )
}
